import React from "react";
import "./WhyFalconSFX.css";
import { IDS } from "../../../utils/common";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { getwhychooseus } from "../../../utils/apis/common/Common";
import SectionTitle from "../../common/common_title/SectionTitle";

function WhyFalconSFX() {
  const cards = [
    {
      img: "/assets/images/home/why-choose-us/professional.png",
      title: "Experienced Solar Professionals",
      text:
        "Years of hands-on experience delivering efficient & reliable solar installations.",
    },
    {
      img: "/assets/images/home/why-choose-us/screw.png",
      title: "Customized Solar Solutions",
      text:
        "Tailor-made systems designed to match your energy needs and budget.",
    },
    {
      img: "/assets/images/home/why-choose-us/component.png",
      title: "High-Quality Components",
      text:
        "We use trusted, certified solar panels and inverters for long-lasting performance.",
    },
    {
      img: "/assets/images/home/why-choose-us/mechanic.png",
      title: "End-to-End Service",
      text:
        "Complete support from consultation to installation and maintenance.",
    },
    {
      img: "/assets/images/home/why-choose-us/save-money.png",
      title: "Maximum Savings Guaranteed",
      text:
        "Optimized system design to help you reduce electricity bills significantly.",
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [whychooseus, setWhyChooseUs] = useState([]);

  const getWhyChoose = async () => {
    const res = await getwhychooseus();
    if (res?.success) {
      setWhyChooseUs(res.data);
    }
  };
  useEffect(() => {
    getWhyChoose();
  }, []);

  return (
    <section className="why_choose_us WhyFalconSFX-section">
      <div className="container text-center">
        <div className="heading-wrapper">
          {" "}
          <SectionTitle
            title="Why Choose Us"
            subtitle="Why "
            redtext="Falcon SFX?"
            className="h-title"
          />
        </div>

        <div className="row g-4 ">
          {whychooseus.map((card, index) => (
            <div
              key={index}
              className="col-6 col-md-4 col-lg-2 col-sm-6 col-custom"
            >
              <div className="why_card h-100 text-start">
                <div className="icon mb-3">
                  <img
                    src={IDS?.IMG_URL + card?.image}
                    // src={card.img}
                    alt={card?.title}
                    className="why_icon_img"
                  />
                </div>
                <h5>{card?.title}</h5>
                {/* <p>{htmlToReactParser.parse(card.description)}</p> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyFalconSFX;
